import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'subscribe-block',
  styleUrl: 'subscribe-block.css',
  shadow: true,
})
export class SubscribeBlock {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * Form ID
   */
  @Prop() formId: string;

  /**
   * Text Orientation
   */
  @Prop() textOrientation: string;

  /**
   * Details Data
   */
  @Prop() detailsData: string;

  /**
   * Asset Type
   */
  @Prop() assetType: string;

  /**
   * Image alt
   */
  @Prop() imageAlt: string;

  /**
   * Image Url
   */
  @Prop() imageUrl: any;

  /**
   * Video
   */
  @Prop() videoUrl: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }

  render() {
    const details = JSON.parse(this.detailsData);

    return (
      <Host>
        <div
          class={`${this.backgroundColor} p-16px flex items-center  justify-center ${this.textOrientation} ${this.paddingBottom} ${this.paddingTop}`}
          style={{ backgroundImage: `url(${this.backgroundImage})` }}
        >
          <div>
            {this.mainTitle && <h3>{this.mainTitle}</h3>}
            {details.length > 0 &&
              details &&
              details.map(detail => (
                <div class={`flex flex-col items-center justify-center text-center`} >
                  <h2>{detail.detail}</h2>
                </div>
              ))}
            {this.formId && <h3>{this.formId}</h3>}
          </div>
          <div class={`max-w-sm`}>
            {this.assetType === 'image' && this.imageUrl && <image-block imageUrl={this.imageUrl} imageAlt={this.imageAlt}></image-block>}
            {this.assetType === 'video' && this.videoUrl && <video-block videoUrl={this.videoUrl}></video-block>}
          </div>
        </div>
      </Host>
    );
  }
}
